var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer min-w-1400 max-w-1400"},[_c('div',{staticClass:"footer-content"},[_c('p',{staticClass:"firstLine"},[_vm._v(" Regulado por la Comisión Nacional Bancaria y la Comisión de Valores ")]),_c('p',{staticClass:"secondLine"},[_vm._v("Copyright © | MARISCOS KANSAN, S. DE R.L. DE C.V.")])])])
}]

export { render, staticRenderFns }